import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { AdmissionCommitteeFormData } from '../data/AdmissionCommitteeForm.Data';
import FormCreator from '../../../components/forms/FormCreator';
import Buttons from '../../../components/ui/button/Buttons';

const AddMemberForm = forwardRef((props, ref) => {
    const addMemberFormRef = useRef();
    const [addMemberForm, setloginForm] = useState(AdmissionCommitteeFormData);

    // Expose method `getFormData` to parent components to retrieve form data from `FormCreator`
    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const addMemberFormData = addMemberFormRef.current.getFormData();
                return addMemberFormData;
            }
            return null;
        }
    }))
    const handleAddMember = () => {
        if (props?.handleSaveMember) {
            props?.handleSaveMember();
        }
    }

    return (
        <div className='container'>
            <div className='row'>
                <FormCreator config={addMemberForm} ref={addMemberFormRef} key={false} />
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                    <Buttons
                        buttonTypeClassName={"btn theme-btn"}
                        buttonText={"Submit"}
                        isLoading={props?.isLoadingAddMember}
                        isDisable={props?.isLoadingAddMember}
                        onClick={handleAddMember}
                    />
                </div>
            </div>
        </div>
    )
})

export default AddMemberForm